// extracted by mini-css-extract-plugin
export default {"controls":"_2w2ADIbfEnzk0NsnJy1Kjl"};